let mutations = {
  transactions(state, data) {
    state.transactions = data.transactions
    state.totalTxnCount = data.totalTxnCount
  },
  updateTransaction(state, data) {
  },
  csv(state, data) {
    state.csv = data
  },
  allTransactions(state, data) {
    state.allTransactions = data.transactions
  },
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/transactions/mutations.js